import { Injectable } from '@angular/core';
import { ConfiguracionInicialService } from './configuracioninicial.service';
import { ComunicacionapiService } from './comunicacionapi.service';
import { Constantes } from '../models/modules/Constantes';
import { Observable } from 'rxjs/internal/Observable';
import { Firma_Electronica_Lista } from '../models/generic/Firma_Electronica_Lista';

@Injectable({
  providedIn: 'root'
})
export class Firma_ElectronicaService {
  
  ListaFirmaElectronica: Firma_Electronica_Lista[] = [];
  
  constructor(private configInicial: ConfiguracionInicialService,
    private comunicacionapiService: ComunicacionapiService) {
      
  }

  ConsultarListas(): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.FIRMA_ELECTRONICA_CONSULTARLISTAS()}`;
    return this.comunicacionapiService.Post(urlServicio);
  }
  Consultar(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.FIRMA_ELECTRONICA_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarPendientes(): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.FIRMA_ELECTRONICA_CONSULTARPENDIENTES()}`;
    return this.comunicacionapiService.Post(urlServicio);
  }
  RefrescarEstado(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.FIRMA_ELECTRONICA_REFRESCARESTADO()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  EnviarRecordatorio(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.FIRMA_ELECTRONICA_ENVIARRECORDATORIO()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  GenerarCodigo(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.FIRMA_ELECTRONICA_GENERARCODIGO()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  Actualizar(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.FIRMA_ELECTRONICA_ACTUALIZAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  Eliminar(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.FIRMA_ELECTRONICA_ELIMINAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  DescargarDocumento(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.FIRMA_ELECTRONICA_DESCARGARDOCUMENTO()}`;
    return this.comunicacionapiService.PostDescarga(urlServicio, parametros);
  }
}
